// import AuralComprehensionIcon from "../assets/mapping_icons/AuralComprehension.svg"; //
import AdditionalAnimationIcon from '../assets/mapping_icons/AdditionalAnimation.svg';
import AnimationIcon from '../assets/mapping_icons/Animation.svg';
import AnswerKeyIcon from '../assets/mapping_icons/Anskey Key.svg';
import AudioIcon from '../assets/mapping_icons/Audio.svg';
import PhonicsAudioIcon from '../assets/mapping_icons/PhonicsAudio.svg';
import BloomTaxonomyWorksheetIcon from '../assets/mapping_icons/BloomsTaxonomyWorksheet.svg';
import BuilderIcon from '../assets/mapping_icons/Builder.svg';
import ChapterAudioIcon from '../assets/mapping_icons/ChapterAudio.svg';
// import ConceptMapIcon from "../assets/mapping_icons/ConceptMap.svg"; //
import CrossCurricularIcon from '../assets/mapping_icons/CrossCurricular.svg';
import DifferentiatedWorksheetIcon from '../assets/mapping_icons/DifferentiatedWorksheet.svg';
import GameIcon from '../assets/mapping_icons/Game.svg';
import GrammarAnimationIcon from '../assets/mapping_icons/GrammarAnimation.svg';
import GrammarChartIcon from '../assets/mapping_icons/GrammarChart.svg';
import InteractiveWorksheetIcon from '../assets/mapping_icons/InteractiveWorksheet.svg';
import InteractivityIcon from '../assets/mapping_icons/Interactivity.svg';
import InteractiveIcon from '../assets/mapping_icons/Interactive.svg';
import AdditionalInteractivityIcon from '../assets/mapping_icons/AdditionalInteractivity.svg'; //
import InfographicsIcon from '../assets/mapping_icons/InformationGraphics.svg';
import LessonPlanIcon from '../assets/mapping_icons/LessonPlan.svg';
import ListeningWorksheetIcon from '../assets/mapping_icons/ListeningWorksheet.svg';
import MindMapIcon from '../assets/mapping_icons/MindMap.svg';
import MentalMathWorksheetIcon from '../assets/mapping_icons/MentalMathWorksheet.svg';
// import NumericalIcon from "../assets/mapping_icons/Numerical.svg"; //
import ThreeDAnimationIcon from '../assets/mapping_icons/3DAnimation.svg';
// import BookletIcon from "../assets/mapping_icons/Booklet.svg"; //
import PensketchDiagramIcon from '../assets/mapping_icons/PensketchDiagram.svg';
// import ProjectsIcon from "../assets/mapping_icons/Projects.svg"; //
// import PictureStudyIcon from "../assets/mapping_icons/PictureStudy.svg"; //
// import ExploreItIcon from "../assets/mapping_icons/ExploreIt.svg"; //
import PictionaryIcon from '../assets/mapping_icons/Pictionary.svg';
import InTextQuestionIcon from '../assets/mapping_icons/InTextQuestion.svg';
import ScientificInquiryIcon from '../assets/mapping_icons/ScientificInquiry.svg';
import ScreenCaptureVideoIcon from '../assets/mapping_icons/ScreenCaptureVideo.svg';
// import SimulationIcon from "../assets/mapping_icons/Simulation.svg"; //
// import TalkingPictureIcon from "../assets/mapping_icons/TalkingPicture.svg"; //
import VideoWorksheetAnswerKeyIcon from '../assets/mapping_icons/VideoWorkSheetAnswerkey.svg';
import VideoWorksheetIcon from '../assets/mapping_icons/VideoWorksheet.svg';
import WorksheetIcon from '../assets/mapping_icons/Worksheet.svg';
// import ZoomFamilyIcon from "../assets/mapping_icons/ZoomFamily.svg"; //
import SearchIcon from '../assets/mapping_icons/Search.svg';
import TakeoffIcon from '../assets/mapping_icons/Takeoff.svg';
import ListeningAudioIcon from '../assets/mapping_icons/ListeningAudio.svg';
import EnrichmentIcon from '../assets/mapping_icons/Enrichment.svg';
import PIEIcon from '../assets/mapping_icons/PIE.svg';
import AgumentRealityInstructorIcon from '../assets/mapping_icons/AgumentedRealityInstructor.svg';
import GrammarMemeIcon from '../assets/mapping_icons/GrammarMeme.svg';
import ProgrammingExplainerVideosIcon from '../assets/mapping_icons/ProgrammingExplainerVideos.svg';
import ChapterOpeningIcon from '../assets/mapping_icons/ChapterOpening.svg';
import ExplainerVideoIcon from '../assets/mapping_icons/ExplainerVideo.svg';
import MathLabActivityIcon from '../assets/mapping_icons/MathLabActivity.svg';
import TryItYourselfIcon from '../assets/mapping_icons/TryItYourself.svg';
import SimulationIcon from '../assets/mapping_icons/Simulation.svg';
import PictureStudyIcon from '../assets/mapping_icons/PictureStudy.svg';
import ProblemSolvingSkillsIcons from '../assets/mapping_icons/ProblemSolvingSkills.svg';
import LifeSkillsAndValuesIcon from '../assets/mapping_icons/LifeSkillAndValues.svg';
import EvaluateIcon from '../assets/mapping_icons/Evaluate.svg';
import UnusedPassageIcon from '../assets/mapping_icons/UnusedPassage.svg';
import GrammarGameIcon from '../assets/mapping_icons/GrammarGame.svg';
import GrammarWorkseetIcon from '../assets/mapping_icons/GrammarWorksheet.svg';
import TimelineIcon from '../assets/mapping_icons/Timelines.svg';
import ChapterWorksheetIcon from '../assets/mapping_icons/ChapterWorksheet.svg';
import WhileReadingQuestionIcon from '../assets/mapping_icons/WhileReadingQuestionExploreIt.svg';
import HomeworkWorksheetIcon from '../assets/mapping_icons/HomeworkWorksheet.svg';
import ImageBasedWorkSheetIcon from '../assets/mapping_icons/ImageBasedWorksheet.svg';
import FlashCardIcon from '../assets/mapping_icons/FlashCard.svg';
import VideoIcon from '../assets/mapping_icons/Video.svg';
import RewindIcon from '../assets/mapping_icons/Rewind.svg';
import ChapterAnimation from '../assets/mapping_icons/ChapterAnimation.svg';
import SynopsisIcon from '../assets/mapping_icons/Synopsis.svg';
import HighlightsIcon from '../assets/mapping_icons/Highlights.svg';
import WalkThroughIcon from '../assets/mapping_icons/WalkThrough.svg';
import IndependentReadingAssistantIcon from '../assets/mapping_icons/IndependentReadingAssistant.svg';
import AdditionalWorksheetIcon from '../assets/mapping_icons/AdditionalWorksheet.svg';
import ConceptAnimationIcon from '../assets/mapping_icons/ConceptAnimation.svg';
interface IconDetails {
    icon_path: string;
    background_hexcode: string;
}

interface IconMap {
    [title: string]: IconDetails;
}

export const nameIconMap: IconMap = {
    Timeline: {
        icon_path: TimelineIcon,
        background_hexcode: '#EEEBF0',
    },
    'Walk Through': {
        icon_path: WalkThroughIcon,
        background_hexcode: '#F3D9DE',
    },
    Highlights: {
        icon_path: HighlightsIcon,
        background_hexcode: '#F3D9DE',
    },
    'Chapter Animation': {
        icon_path: ChapterAnimation,
        background_hexcode: '#EAF1D5',
    },
    'Concept Animation': {
        icon_path: ConceptAnimationIcon,
        background_hexcode: '#EAF1D5',
    },
    'Unused Passage': {
        icon_path: UnusedPassageIcon,
        background_hexcode: '#F5E6E6',
    },
    'Life Skills and Values': {
        icon_path: LifeSkillsAndValuesIcon,
        background_hexcode: '#FFEEE9',
    },
    'Life Skill': {
        icon_path: LifeSkillsAndValuesIcon,
        background_hexcode: '#FFEEE9',
    },
    'Problem Solving Skills': {
        icon_path: ProblemSolvingSkillsIcons,
        background_hexcode: '#E1F2F8',
    },
    'Homework Worksheet': {
        icon_path: HomeworkWorksheetIcon,
        background_hexcode: '#F3D9DE',
    },

    'Chapter Worksheet': {
        icon_path: ChapterWorksheetIcon,
        background_hexcode: '#EAF1D5',
    },
    'Chapter Opening': {
        icon_path: ChapterOpeningIcon,
        background_hexcode: '#E0F4FB',
    },
    'Explainer Video': {
        icon_path: ExplainerVideoIcon,
        background_hexcode: '#DCFAF2',
    },
    'Programming Explainer Videos': {
        icon_path: ProgrammingExplainerVideosIcon,
        background_hexcode: '#DFF4FF',
    },
    'Grammar Worksheet': {
        icon_path: GrammarWorkseetIcon,
        background_hexcode: '#F6EBFC',
    },
    'Grammar Meme': {
        icon_path: GrammarMemeIcon,
        background_hexcode: '#DFF4FF',
    },
    IRA: {
        icon_path: IndependentReadingAssistantIcon,
        background_hexcode: 'linear-gradient(90deg, #323693 0%, #763D96 100%)',
    },
    'Independent Reading Assistant': {
        icon_path: IndependentReadingAssistantIcon,
        background_hexcode: 'linear-gradient(90deg, #323693 0%, #763D96 100%)',
    },
    ARI: {
        icon_path: AgumentRealityInstructorIcon,
        background_hexcode: 'linear-gradient(90deg, #323693 0%, #763D96 100%)',
    },
    'Agument Reality Instructor': {
        icon_path: AgumentRealityInstructorIcon,
        background_hexcode: 'linear-gradient(90deg, #323693 0%, #763D96 100%)',
    },
    PIE: {
        icon_path: PIEIcon,
        background_hexcode: 'linear-gradient(90deg, #F14A30 0%, #F57C24 100%)',
    },
    'Personalised Interactive Exercises': {
        icon_path: PIEIcon,
        background_hexcode: 'linear-gradient(90deg, #F14A30 0%, #F57C24 100%)',
    },
    Rewind: {
        icon_path: RewindIcon,
        background_hexcode: '#FFEBD4',
    },
    Pictionary: {
        icon_path: PictionaryIcon,
        background_hexcode: '#DAF9F7',
    },
    Search: {
        icon_path: SearchIcon,
        background_hexcode: '#E4EBEF',
    },
    Enrichment: {
        icon_path: EnrichmentIcon,
        background_hexcode: '#E4EBEF',
    },
    'Additional Interactivity': {
        icon_path: AdditionalInteractivityIcon,
        background_hexcode: '#EAF1D5',
    },
    'Information Graphics': {
        icon_path: InfographicsIcon,
        background_hexcode: '#F7E7FF',
    },
    'Aural Comprehension': {
        icon_path: '', //AuralComprehensionIcon,
        background_hexcode: '#DFF4FF',
    },
    'Additional Animation': {
        icon_path: AdditionalAnimationIcon,
        background_hexcode: '#FFDEE9',
    },
    'Additional Answer Key': {
        icon_path: AnswerKeyIcon,
        background_hexcode: '#EEEBF0',
    },
    Animation: {
        icon_path: AnimationIcon,
        background_hexcode: '#D4EFF9',
    },
    'Answer Key': {
        icon_path: AnswerKeyIcon,
        background_hexcode: '#EEEBF0',
    },
    Audio: {
        icon_path: AudioIcon,
        background_hexcode: '#E4EBEF',
    },
    'Phonics Audio': {
        icon_path: PhonicsAudioIcon,
        background_hexcode: '#E4EBEF',
    },
    'Image Based Worksheet': {
        icon_path: ImageBasedWorkSheetIcon,
        background_hexcode: '#F5E6E6',
    },
    "Bloom's Taxonomy Worksheet": {
        icon_path: BloomTaxonomyWorksheetIcon,
        background_hexcode: '#F5E6E6',
    },
    'Buildr Lab Activity': {
        icon_path: BuilderIcon,
        background_hexcode: '#DDE5FA',
    },
    Buildr: {
        icon_path: BuilderIcon,
        background_hexcode: '#DDE5FA',
    },
    'Chapter Audio': {
        icon_path: ChapterAudioIcon,
        background_hexcode: '#DAF9F7',
    },
    'Take off': {
        icon_path: TakeoffIcon,
        background_hexcode: '#DEEFEF',
    },
    'Concept Map': {
        icon_path: EnrichmentIcon,
        background_hexcode: '#EAF1D5',
    },
    'Cross Curricular': {
        icon_path: CrossCurricularIcon,
        background_hexcode: '#DEEFEF',
    },
    'Differentiated Worksheets': {
        icon_path: DifferentiatedWorksheetIcon,
        background_hexcode: '#F4F1D3',
    },
    'Differentiated Worksheet': {
        icon_path: DifferentiatedWorksheetIcon,
        background_hexcode: '#F4F1D3',
    },
    'While reading question': {
        icon_path: WhileReadingQuestionIcon,
        background_hexcode: '#F3D9DE',
    },
    'Listening Worksheet': {
        icon_path: ListeningWorksheetIcon,
        background_hexcode: '#DDE5FA',
    },
    'Listening Audio': {
        icon_path: ListeningAudioIcon,
        background_hexcode: '#FFDEE9',
    },
    Flashcard: {
        icon_path: FlashCardIcon,
        background_hexcode: '#F6EBFC',
    },
    Game: {
        icon_path: GameIcon,
        background_hexcode: '#EAF1D5',
    },
    'Grammar Animation': {
        icon_path: GrammarAnimationIcon,
        background_hexcode: '#F3D9DE',
    },
    'Grammar Chart': {
        icon_path: GrammarChartIcon,
        background_hexcode: '#DDE5FA',
    },
    Evaluate: {
        icon_path: EvaluateIcon,
        background_hexcode: '#E1F2F8',
    },

    'Grammar Game': {
        icon_path: GrammarGameIcon,
        background_hexcode: '#F6EBFC',
    },
    'Interactive Worksheet': {
        icon_path: InteractiveWorksheetIcon,
        background_hexcode: '#DAE8FB',
    },
    Interactivity: {
        icon_path: InteractivityIcon,
        background_hexcode: '#F3D9DE',
    },
    Infomationgraphics: {
        icon_path: InfographicsIcon,
        background_hexcode: '#F7E7FF',
    },
    'Lesson Plan': {
        icon_path: LessonPlanIcon,
        background_hexcode: '#EAF1D5',
    },
    'Mind Map': {
        icon_path: MindMapIcon,
        background_hexcode: '#FFEDD4',
    },
    Synopsis: {
        icon_path: SynopsisIcon,
        background_hexcode: '#FFEBD4',
    },
    'Math Lab Activity': {
        icon_path: MathLabActivityIcon,
        background_hexcode: '#DCFAF2',
    },
    'Maths Lab Activity': {
        icon_path: MathLabActivityIcon,
        background_hexcode: '#DCFAF2',
    },
    Numerical: {
        icon_path: '', //NumericalIcon,
        background_hexcode: '#F3D9DE',
    },
    '3D Animation': {
        icon_path: ThreeDAnimationIcon,
        background_hexcode: '#EAF1D5',
    },
    '3D': {
        icon_path: ThreeDAnimationIcon,
        background_hexcode: '#EAF1D5',
    },
    Booklet: {
        icon_path: '', //BookletIcon,
        background_hexcode: '',
    },
    'Pensketch Diagram': {
        icon_path: PensketchDiagramIcon,
        background_hexcode: '#FFE6F4',
    },
    Projects: {
        icon_path: '', //ProjectsIcon,
        background_hexcode: '#E1F2F8',
    },
    'Picture Study': {
        icon_path: PictureStudyIcon,
        background_hexcode: '#E1F2F8',
    },
    'Explore it': {
        icon_path: '', // ExploreItIcon,
        background_hexcode: '#F3D9DE',
    },
    'in-text question': {
        icon_path: InTextQuestionIcon,
        background_hexcode: '#FFEBD4',
    },
    'Try it Yourself': {
        icon_path: TryItYourselfIcon,
        background_hexcode: '#F3D9DE',
    },
    'Scientific Inquiry': {
        icon_path: ScientificInquiryIcon,
        background_hexcode: '#F5E6E6',
    },
    'Sci Inqry': {
        icon_path: ScientificInquiryIcon,
        background_hexcode: '#F5E6E6',
    },
    'Screen Capture Video': {
        icon_path: ScreenCaptureVideoIcon,
        background_hexcode: '#F6EBFC',
    },
    Simulation: {
        icon_path: SimulationIcon,
        background_hexcode: '#F3D9DE',
    },
    'Talking Picture': {
        icon_path: '', //TalkingPictureIcon,
        background_hexcode: '',
    },
    Video: {
        icon_path: VideoIcon,
        background_hexcode: '#FDE6E6',
    },
    'Video Worksheet Answer Key': {
        icon_path: VideoWorksheetAnswerKeyIcon,
        background_hexcode: '#F5E6E6',
    },
    'Video Worksheet': {
        icon_path: VideoWorksheetIcon,
        background_hexcode: '#E1F2F8',
    },
    Worksheet: {
        icon_path: WorksheetIcon,
        background_hexcode: '#DAE8FB',
    },
    'Worksheet-A': {
        icon_path: WorksheetIcon,
        background_hexcode: '#DAE8FB',
    },
    'Worksheet-B': {
        icon_path: WorksheetIcon,
        background_hexcode: '#DAE8FB',
    },
    'Worksheet-C': {
        icon_path: WorksheetIcon,
        background_hexcode: '#DAE8FB',
    },
    'Additional Worksheet': {
        icon_path: AdditionalWorksheetIcon,
        background_hexcode: '#DAE8FB',
    },
    'Mental Math Worksheet': {
        icon_path: MentalMathWorksheetIcon,
        background_hexcode: '#F4F1D3',
    },

    'Zoom Family': {
        icon_path: '', //ZoomFamilyIcon,
        background_hexcode: '',
    },
    Interactive: {
        icon_path: InteractiveIcon,
        background_hexcode: '#DAF9F7',
    },
};
